<mat-toolbar class="header">
  <div class="header-content">
    <div class="header-left">
      <button mat-icon-button class="menu-toggle">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="page-title">Панель управління</span>
    </div>

    <div class="header-right">
      <button mat-icon-button [matBadge]="notificationsCount" matBadgeColor="warn">
        <mat-icon>notifications</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-button">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #userMenu="matMenu" class="user-menu">
        <div class="user-info">
          <div class="user-avatar">
            <mat-icon>account_circle</mat-icon>
          </div>
          <div class="user-details">
            <strong>Test Admin</strong>
            <small>admin&#64;urbix.com</small>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item>
          <mat-icon>person</mat-icon>
          <span>Профіль</span>
        </button>
        <button mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>Налаштування</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Вийти</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
